<bb-input-validation-message-ui data-role="input-error" (focusout)="onFocusout()" *ngIf="control"
  [showErrors]="control?.touched && control?.invalid">
  <ng-container *ngIf="control?.errors && control?.errors['required']; else invalidError">
    <span data-role="required-error" [attr.id]="id">
      <ng-container *ngIf="getRequiredMessage(); else requiredError">
        {{ requiredMessage }}
      </ng-container>
    </span>
  </ng-container>

  <ng-template #requiredError>
    <ng-container i18n="@@dynamic-form-field-default-validation-message.required.error">
      {{ label }} is required
    </ng-container>
  </ng-template>

  <ng-template #invalidError>
    <span data-role="required-error" [attr.id]="id">
      <ng-container *ngIf="getValidationMessage(); else genericError">
        {{ validationMessage }}
      </ng-container>
    </span>
  </ng-template>

  <ng-template #genericError>
    <ng-container *ngIf="!hideGeneric" i18n="@@dynamic-form-field-default-validation-message.generic.error">
      Invalid {{ label }}
    </ng-container>
  </ng-template>
</bb-input-validation-message-ui>